var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#bdc3c7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#93cfef",
    d: "M45.2 42.52V69l21.52-10.76V31.76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d87070",
    d: "M44.8 42.52V69L23.29 58.24V31.76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#464c63",
    d: "M44.8 70a1 1 0 0 1-.45-.11L22.84 59.14a1 1 0 0 1-.55-.89V31.76a1 1 0 1 1 2 0v25.86l19.51 9.76V42.52a1 1 0 0 1 2 0V69a1 1 0 0 1-1 1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d87070",
    d: "M44.8 42.52V69L23.29 58.24V31.76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#464c63",
    d: "M44.8 70a1 1 0 0 1-.45-.11L22.84 59.14a1 1 0 0 1-.55-.89V31.76a1 1 0 1 1 2 0v25.86l19.51 9.76V42.52a1 1 0 0 1 2 0V69a1 1 0 0 1-1 1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fabd6b",
    d: "M44.8 42.52L23.29 31.76 43.98 21l22.34 10.76L44.8 42.52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#464c63",
    d: "M44.8 43.52a1 1 0 0 1-.45-.11L22.84 32.65a1 1 0 0 1 0-1.78l20.67-10.76a1 1 0 0 1 .9 0l22.34 10.75a1 1 0 0 1 0 1.8l-21.5 10.75a1 1 0 0 1-.45.11zM25.49 31.74L44.8 41.4l19.25-9.62L44 22.12z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#464c63",
    d: "M44.8 70a1 1 0 0 1-.45-1.89l21-10.48V31.76a1 1 0 1 1 2 0v26.48a1 1 0 0 1-.55.89L45.25 69.89a1 1 0 0 1-.45.11z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.5aeefbbb4628e94f7f9a07a8cdbd1424.svg";
export { ForwardRef as ReactComponent };